import { put, takeLatest } from 'redux-saga/effects';
import { taskCollection } from 'collections/tasks';
import { FetchStatus } from 'data/core';
import { spaceTabSuccessSagaAction } from '../actions';
import { saveNormalizedSpaceTabs } from '../index';
import { spaceTabNormalizer } from '../schema';
function* spaceTabSuccessSaga({ payload }) {
    var _payload_taskList;
    const { entities: { spaceTabs } } = spaceTabNormalizer(payload);
    // Push the RAW api-shaped tasks (not normalizr output, which flattens
    // subTasks/project to ids). The collection is the api-shape source of truth.
    if ((_payload_taskList = payload.taskList) === null || _payload_taskList === void 0 ? void 0 : _payload_taskList.length) {
        taskCollection.push(payload.taskList);
    }
    if (spaceTabs) {
        yield put(saveNormalizedSpaceTabs({
            data: spaceTabs,
            fetchStatus: FetchStatus.Loaded
        }));
    }
}
export function* watchSpaceTabSuccessSaga() {
    yield takeLatest(spaceTabSuccessSagaAction.type, spaceTabSuccessSaga);
}
